module.exports = __webpack_public_path__ + "static/media/background-gradation-bottom-Tablet.3d9962c3.png";